module.exports = __webpack_public_path__ + "914cfc8d294578868ce0c72b9daa6890.png";